define(['angular', '../module'], function(angular, MODULE_NAME) {
    'use strict';

    var SERVICE_NAME = '$ilmnUiIdleMonitoringService';

    angular.module(MODULE_NAME)
        .service(SERVICE_NAME, IlmnIdleMonitoringService);


    IlmnIdleMonitoringService.$inject = ['$log', '$rootScope', 'Idle', 'Keepalive', '$ilmnUiIdleService', '$ilmnUiAlertBannerService', '$injector', '$ilmnUiSessionTracker'];
    function IlmnIdleMonitoringService($log, $rootScope, $idle, $keepalive, $ilmnUiIdleService, $ilmnUiAlertBannerService, $injector, $ilmnUiSessionTracker) {
        var alertBanner;

        return {
            start: start
        };

        function start() {
            if($ilmnUiIdleService.isDisabled()) {
                throw Error("ilmn-ui-idle: Idle service has been disabled");
            }

            $idle.watch();

            $keepalive.ping(); //Send heartbeat on app startup

            log('Watching user activity now', new Date().toLocaleTimeString());
            log('idleTimeout: '+($idle.getIdle()/60)+'m idleTimeoutWarning: '+($idle.getTimeout()/60)+'m');

            $rootScope.$on("IdleStart", onUserIdle);
            $rootScope.$on('IdleEnd', onUserBack);
            $rootScope.$on("IdleTimeout", onUserTimeout);
            $rootScope.$on('$ilmnUiIdle.userLogout', onUserLoggedOut);
            $rootScope.$on('$ilmnUiIdle.platformError', logout);

            $rootScope.$on('Keepalive', function() {
                log('KeepAlive Called');
            });

            $rootScope.$on('KeepaliveResponse', function(){
                log('Keepalive Response')
            })
            $rootScope.$on('IdleInterrupt', function () {
                log('Idle Interrupted (Timers will reset)');
            });
        }

        function log(msg) {
            $ilmnUiIdleService.log(msg);
        }

        function logout() {
            $ilmnUiAlertBannerService.clearBanners();
            $ilmnUiAlertBannerService.show({
                message: 'For your safety, we automatically logged you out of your account after '+ ($idle.getIdle() / 60)+' minutes of inactivity. Sign in again to continue.',
                type: 'success'
            });
            $ilmnUiIdleService.logout();
        }

        function onUserIdle() {
            log("Hey, do something.. or I'll log you out (IdleStart)");

            try {
                var $uibModalStack = $injector.get('$uibModalStack');
                $uibModalStack.dismissAll();
            }
            catch (e) {}

            alertBanner = $ilmnUiAlertBannerService.show({
                message: 'Are you still there? In order to keep your data safe, this session will end after ' + ($idle.getIdle() / 60) + ' minutes of inactivity.',
                overlay: true,
                buttons: [
                    {
                        label: 'Sign Out',
                        action: function () {
                            $log.debug('User clicked logout');
                            alertBanner.close();
                            $ilmnUiIdleService.logout();
                            $idle.unwatch();
                        }
                    },
                    {
                        label: 'Stay Signed In',
                        buttonClass: 'primary',
                        action: function () {
                            $idle.interrupt();
                            alertBanner.close();
                        }
                    }
                ]
            });
        }

        function onUserBack() {
            log('Phew, you are back.. I was about to log you out.');
            alertBanner.close();
        }

        function onUserTimeout(){
            $ilmnUiSessionTracker.isIdle().then(function(response) {
                if(response && response.data && response.data.isIdle) {
                    $log.error("ilmn-ui-idle: Hey, Sorry... we are logging you out due to inactivity");
                    logout();
                }
                else {
                    log('User not idle on other application');
                    $idle.watch();
                }
            });
        }

        function onUserLoggedOut() {
            $idle.unwatch();
            $keepalive.stop();
        }
    }

    return SERVICE_NAME;
});



//////////////////
// WEBPACK FOOTER
// ./ilmn-ui-idle/scripts/idleMonitoring.service.js
// module id = 45
// module chunks = 0 1